import { FC } from 'react'

import {
  IconArrowRotateRightLeft,
  Button,
  Flex
} from '@sequencehq/core-components'
import { useRegeneratePdfAction } from '../hooks/useRegeneratePdfAction'

type Props = {
  quoteId: string
  quoteVariantId?: string
}

export const RegeneratePdfAction: FC<Props> = ({ quoteId, quoteVariantId }) => {
  const { regeneratePdf, isPending } = useRegeneratePdfAction({
    quoteId,
    quoteVariantId
  })

  return (
    <Flex gap="8px" alignItems="center" width="100%">
      <Button
        variant="secondary"
        style={{ flex: 1 }}
        submitting={isPending}
        submittingText="Generating PDF"
        leadingIcon={<IconArrowRotateRightLeft color="inherit" />}
        onClick={regeneratePdf}
        data-testid="watchtower.notification.regeneratePdf"
      >
        Regenerate PDF
      </Button>
    </Flex>
  )
}
